<template>
    <div class="antialiased">
      <Sidebar />
      <div class="page">
        <Header></Header>
        <div class="content">
            <div class="container">
                <!-- Page title -->
                <div class="page-header pb-4 border-bottom">
                    <div class="d-flex justify-content-between">
                        <h2 class="page-title">Tracking Service Level Sales</h2>
                        <div>
                            <button
                                class="btn btn-white"
                                v-html="ic('filter') + ' Filter'"
                                @click="_filter"
                            >
                            </button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info" v-if="!isFilter">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat Tracking Service Level Sales
                </div>
                <Nodata v-if="!loading && report.length == 0"/>
                <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
                <div class="text-center my-6" v-if="!loading && report.length > 0">
                    <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
                    <h3 class="my-3" v-html="`${report.length} Data`"></h3>
                    <button class="btn btn-primary" :disabled="isDownload" @click="_createExcel()" v-html="isDownload ? spin() : 'Export Excel'"></button>
                </div>
            </div>
        </div>
      </div>

      <!-- Section Modals -->
      <FormFilter
        :isOpen.sync="modals.filter.view"
        @submit="modals.filter.action"
        />
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import XLSX from 'xlsx';

export default {
    name: "TrackingServiceLevelSales",
    components: { FormFilter },
    data() {
        return{
            loading: false,
            isFilter: false,
            isDownload: false,
            start_date: '',
            end_date: '',
            report: [],
            modals:{
                filter:{
                    view: false,
                    action: () => {}
                }
            }
        }
    },
    mixins: [helper],
    methods: {
        _filter(){
            this.modals.filter.view = true
            this.modals.filter.action = async (filter) => {
                this.loading = true;
                this.start_date = filter.start_date
                this.end_date = filter.end_date
                this.axios.get("report/tracking/service-level/sales", {params: filter})
                    .then((res) => {
                        this.start_date = filter.start_date
                        this.end_date = filter.end_date
                        this.report = [],
                        this.isFilter = true;
                        this.report = res.data;
                    })
                    .catch((err) => {
                        this.onError(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },

        // get cell reference for XLSX eg: row 37, col 1 = AA1
        getCellRef(row, col) {
            const colLetter = XLSX.utils.encode_col(col - 1);
            return `${colLetter}${row}`;
        },
        // 

        async mappingReportPerSheet(reportBySalesman){
            let configurationMergeReport = [];
            let reportPerSheet = [
                ["","", ""],
                ["CODE PRODUCT", "PRODUCT", "BARCODE"],
                ["", "", ""],
            ];
            // config merge for data product
            for (let i = 0; i < 3; i++) {
                configurationMergeReport.push({
                    s: { r: 1, c: i }, // Start at row 1, column i
                    e: { r: 2, c: i }  // End at row 2, column i
                });
                
                const cellHeader = this.getCellRef(2, i + 1);
            }

            let indexStartReport = 3;
            const totalProduct = reportBySalesman.list_barang.length;
            const totalLengthReportRow = totalProduct + indexStartReport;
            let reportPerProduct = [];
            
            reportBySalesman.list_toko.forEach((nama_toko, index) => {
                // setup summary for top report use formula
                const indexColSummaryPO = indexStartReport + 1;
                const indexColSummaryReal = indexStartReport + 2;
                const cellStartSummaryPO = this.getCellRef(4,indexColSummaryPO);
                const cellEndSummaryPO = this.getCellRef(totalLengthReportRow,indexColSummaryPO);
                const cellStartSummaryReal = this.getCellRef(4,indexColSummaryReal);
                const cellEndSummaryReal = this.getCellRef(totalLengthReportRow,indexColSummaryReal);
                reportPerSheet[0].push(
                    {
                        f: `SUBTOTAL(9,${cellStartSummaryPO}:${cellEndSummaryPO})`, 
                        t: 'n',z: '#,##0.00'
                    },
                    { 
                        f: `SUBTOTAL(9,${cellStartSummaryReal}:${cellEndSummaryReal})`, 
                        t: 'n',z: '#,##0.00'
                    },
                    { 
                        f: `IFERROR(${this.getCellRef(1,indexColSummaryReal)}/${this.getCellRef(1,indexColSummaryPO)},0)`, 
                        t: 'n',z: '#,##0.00'
                    }
                );

                // create header horizontal name toko
                reportPerSheet[1].push(nama_toko,'','');
                reportPerSheet[2].push('PO','REAL','SL');
                // config merge for header toko
                configurationMergeReport.push({
                    s: { r: 1, c: indexStartReport },
                    e: { r: 1, c: indexStartReport+2 } 
                });
                indexStartReport = indexStartReport + 3;
                
                // generate report reportPerProduct data barang
                reportBySalesman.list_barang.forEach((product, index) => {
                    if(!reportPerProduct[product.kode_barang]){
                        reportPerProduct[product.kode_barang] = [
                            product.kode_barang,
                            product.nama_barang,
                            product.barcode,
                        ]
                    }
                    const reportOrderOutlet = reportBySalesman.penjualan.find(item => item.kode_barang === product.kode_barang && item.nama_toko === nama_toko)
                    let po = 0;
                    let real = 0;
                    let serviceLevel = 0;
                    if (reportOrderOutlet) {
                        po = parseFloat(reportOrderOutlet.in_carton_order);
                        real = parseFloat(reportOrderOutlet.in_carton_realisasi);
                        serviceLevel = ((real / po) * 100).toFixed(2);
                    }
                    reportPerProduct[product.kode_barang].push(...[po, real, serviceLevel])
                })
            })

            reportBySalesman.list_barang.forEach((product, index) => {
                const reportProduct = reportPerProduct[product.kode_barang];
                let totalPO = 0;
                let totalReal = 0;
                for (let i = 3; i < reportProduct.length; i += 3) {
                    totalPO += reportProduct[i]
                    totalReal += reportProduct[i+1]
                }
                let totalServiceLevel = totalReal / totalPO * 100;
                let totalLossPO =  totalPO - totalReal;
                reportPerProduct[product.kode_barang].push(totalPO,totalReal,totalServiceLevel,totalLossPO);
            })

            // merge reportPerProduct to reportPerSheet
            reportPerSheet.push(...Object.values(reportPerProduct));
            
            // create summary for end of column
            const indexColTotalPO = indexStartReport + 1;
            const indexColTotalReal = indexStartReport + 2;
            const indexColTotalLossValue = indexStartReport + 4;
            reportPerSheet[0].push(
                {
                    f: `SUBTOTAL(9,${this.getCellRef(4,indexColTotalPO)}:${this.getCellRef(totalLengthReportRow,indexColTotalPO)})`, 
                    t: 'n',z: '#,##0.00'
                },
                { 
                    f: `SUBTOTAL(9,${this.getCellRef(4,indexColTotalReal)}:${this.getCellRef(totalLengthReportRow,indexColTotalReal)})`, 
                    t: 'n',z: '#,##0.00'
                },
                { 
                    f: `IFERROR(${this.getCellRef(1,indexColTotalReal)}/${this.getCellRef(1,indexColTotalPO)},0)`, 
                    t: 'n',z: '#,##0.00'
                },
                { 
                    f: `SUBTOTAL(9,${this.getCellRef(4,indexColTotalLossValue)}:${this.getCellRef(totalLengthReportRow,indexColTotalLossValue)})`, 
                    t: 'n',z: '#,##0.00'
                },
            );
            reportPerSheet[1].push('TOTAL','','','');
            reportPerSheet[2].push('PO','REAL','SL','LOSS PO');
            configurationMergeReport.push({
                s: { r: 1, c: indexStartReport },
                e: { r: 1, c: indexStartReport+3 } 
            });

            return [
                reportPerSheet,
                configurationMergeReport,
            ];
        },

        async _createExcel(){
            this.isDownload = true;
            // add delay for update UI
            await new Promise(resolve => setTimeout(resolve, 50));            
            try {
                const workbook = XLSX.utils.book_new();
                for (const reportBySalesman of this.report) {
                    const [report, configMerge] = await this.mappingReportPerSheet(reportBySalesman);
                    const sheet_data = XLSX.utils.aoa_to_sheet(report);
                    if (!sheet_data['!merges']) sheet_data['!merges'] = configMerge;
                    sheet_data["!cols"] = [{ wch: 18 }, { wch: 35 }, { wch: 18 }];
                    const sheet_name = reportBySalesman.nama_salesman;
                    XLSX.utils.book_append_sheet(workbook, sheet_data, sheet_name);            
                }
                XLSX.writeFile(workbook, `report-tracking-sales-${this.start_date}_${this.end_date}.xlsx`);
            } catch (error) {
                this.onError(error);
            } finally {
                this.isDownload = false;
            }
        },
    }
}
</script>